/* eslint-disable @typescript-eslint/no-explicit-any */
import { SelectWithSearch } from "@/components/form-input";
import { SelectRetailer } from "@/components/form-input/select-retailer";
import { Button } from "@/components/ui/button";
import { LoaderCircle, XIcon } from "lucide-react";
import { useEffect, useState } from "react";
import { createPortal } from "react-dom";

type ReprocessDocumentState = {
  workflow_id: string | undefined;
  doc_id: string | undefined;
};

type ReprocessDocumentProps = {
  allRetailerList: any;
  selectedRetailer: any;
  workflowList: any;
  currentCompanyData: any;
  onAction: any;
  doc_id: any;
  isReprocess: boolean;
  disabled?: boolean;
};
export const ReprocessDocument = ({
  workflowList,
  currentCompanyData,
  onAction,
  doc_id,
  isReprocess,
  allRetailerList,
  selectedRetailer,
  disabled,
}: ReprocessDocumentProps) => {
  const [open, setOpen] = useState(false);
  const [retailerId, setRetailerId] = useState(selectedRetailer);

  const [reprocessDocumentState, setReprocessDocumentState] =
    useState<ReprocessDocumentState>({
      workflow_id: undefined,
      doc_id: undefined,
    });

  useEffect(() => {
    setReprocessDocumentState((prev) => ({
      ...prev,
      workflow_id: currentCompanyData?.settings?.default_workflow,
    }));
  }, [currentCompanyData]);

  useEffect(() => {
    setReprocessDocumentState((prev) => ({
      ...prev,
      doc_id: doc_id,
    }));
  }, [doc_id]);

  const onSubmit = () => {
    if (reprocessDocumentState.doc_id && reprocessDocumentState.workflow_id) {
      setOpen(false);
      if (retailerId === "") {
        onAction({
          doc_id: reprocessDocumentState.doc_id,
          workflow_id: reprocessDocumentState.workflow_id,
        });
      } else {
        onAction({
          doc_id: reprocessDocumentState.doc_id,
          workflow_id: reprocessDocumentState.workflow_id,
          retailer_id: retailerId,
        });
      }
    }
  };

  return (
    <div>
      <Button
        variant={"outline"}
        disabled={disabled}
        onClick={() => setOpen(true)}
      >
        Reprocess Document{" "}
        {isReprocess ? <LoaderCircle className="animate-spin" /> : null}
      </Button>
      {open
        ? createPortal(
            <div className="fixed left-0 top-0 w-full h-full bg-black/50 flex justify-center items-center z-[999]">
              <div className="bg-white w-[45%] rounded-md flex flex-col relative">
                <div className="justify-between items-center w-full flex border border-l-0 border-r-0 border-t-0 px-6 py-2 mb-3 pr-2">
                  <h3 className="text-md font-bold">Document Reprocess</h3>
                  <Button variant={"ghost"} onClick={() => setOpen(false)}>
                    <XIcon />
                  </Button>
                </div>
                <div className="flex flex-col gap-x-6 gap-y-5 pt-4 px-6">
                  <SelectWithSearch
                    bindLabel="name"
                    bindValue="workflow_id"
                    placeholder="Select Workflow"
                    options={workflowList}
                    defaultValue={
                      currentCompanyData?.settings?.default_workflow
                    }
                    onChange={(prop: string) =>
                      setReprocessDocumentState((prev) => ({
                        ...prev,
                        workflow_id: prop,
                      }))
                    }
                    value={reprocessDocumentState.workflow_id}
                  />
                </div>
                <div className="flex flex-col gap-x-6 gap-y-5 pt-4 px-6">
                  <SelectRetailer
                    bindLabel="retailer_name"
                    bindValue="retailer_id"
                    placeholder="Select Retailer"
                    options={allRetailerList}
                    defaultValue={selectedRetailer}
                    onChange={(prop: string) => setRetailerId(prop)}
                    value={retailerId}
                    clearable={true}
                  />
                </div>
                <div className="mt-10 px-6 py-4 flex gap-5 w-full border border-r-0 border-l-0 border-b-0">
                  <Button
                    type="submit"
                    className="w-[220px]"
                    onClick={() => onSubmit()}
                    // disabled={form.formState.isSubmitting}
                  >
                    Reprocess Document
                  </Button>
                  <Button
                    type="submit"
                    onClick={() => setOpen(false)}
                    variant={"outline"}
                    className="w-[220px]"
                  >
                    Close
                  </Button>
                </div>
              </div>
            </div>,
            document.body,
          )
        : null}
    </div>
  );
};
